import './App.css';
import React, { useEffect, Suspense, lazy } from 'react';
import { useState } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Phone from './components/phone/Phone';
import { GiHamburgerMenu } from "react-icons/gi";
import Acasa from './components/Acasa/Acasa';
import Footer from './components/Footer/Footer';
import { useTranslation } from 'react-i18next';
import './i18n';
import logo from '../src/assets/logo.png';

// Lazy-loaded route components for code splitting
const Contact = lazy(() => import('./components/Contact/Contact'));
const Servicii = lazy(() => import('./components/Servicii/Servicii'));
const Despre = lazy(() => import('./components/Despre/Despre'));
const Admin = lazy(() => import('./components/Admin/Admin'));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [mobileMenu,setMobileMenu]=useState(false)
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  useEffect(()=>{
    setMobileMenu(false)
  },[location.pathname])

  useEffect(() => {
      changeLanguage('ro')
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };

    const logoClick=()=>{
      navigate('/');
    }
  
  return (
    <div className="App">
       <ScrollToTop />
       {!isAdminPage && <Phone/>}
       {!isAdminPage && (
       <nav className='nav padding' aria-label="Navigare principală">
          <div className='logo' onClick={logoClick} role="button" tabIndex={0} onKeyDown={(e)=>{if(e.key==='Enter')logoClick()}}>
            <img className='logo-main' src={logo} alt="Daimond Expert Logo" width="80" height="80" />
          </div>
          <ul className='menu-list'>
            <li className={location.pathname === '/' ? 'current-page' : ''}>
              <button type="button" className='nav-link-btn' onClick={() => { navigate('/'); }}>{t('acasa')}</button>
            </li>
            <li className={location.pathname === '/despre' ? 'current-page' : ''}>
              <button type="button" className='nav-link-btn' onClick={() => { navigate('/despre'); }}>{t('despre')}</button>
            </li>
            <li className={location.pathname === '/servicii' ? 'current-page' : ''}>
              <button type="button" className='nav-link-btn' onClick={() => { navigate('/servicii'); }}>{t('servicii')}</button>
            </li>
            <li className={location.pathname === '/contact' ? 'current-page' : ''}>
              <button type="button" className='nav-link-btn' onClick={() => { navigate('/contact'); }}>{t('contact')}</button>
            </li>
          </ul>
          <div className='buttons-div'>
             <button className='contact-btn' onClick={()=>{navigate('/contact')}}>{t('contact_us')}</button>
              <div className='lang-div'>
                <button onClick={() => changeLanguage('ro')} className='ro-btn' aria-label="Schimbă limba în Română">Ro</button>
                <button onClick={() => changeLanguage('en')} className='en-btn' aria-label="Switch language to English">En</button>
              </div>
          </div>
         
          
          <button type="button" className='menu-icon-btn' onClick={()=>{setMobileMenu(!mobileMenu)}} aria-label="Deschide meniul de navigare" aria-expanded={mobileMenu}>
            <GiHamburgerMenu className='menu-icon' aria-hidden="true" />
          </button>
          <div className={`mobile-menu ${mobileMenu ? 'mobile-menu-open':'mobile-menu-close'}`}>
            <ul className='menu-list-mobile'>
              <li className={location.pathname === '/' ? 'current-page' : ''}>
                <button type="button" className='nav-link-btn-mobile' onClick={() => { navigate('/'); }}>{t('acasa')}</button>
              </li>
              <li className={location.pathname === '/despre' ? 'current-page' : ''}>
                <button type="button" className='nav-link-btn-mobile' onClick={() => { navigate('/despre'); }}>{t('despre')}</button>
              </li>
              <li className={location.pathname === '/servicii' ? 'current-page' : ''}>
                <button type="button" className='nav-link-btn-mobile' onClick={() => { navigate('/servicii'); }}>{t('servicii')}</button>
              </li>
              <li className={location.pathname === '/contact' ? 'current-page' : ''}>
                <button type="button" className='nav-link-btn-mobile' onClick={() => { navigate('/contact'); }}>{t('contact')}</button>
              </li>
            </ul>
            <div className='lang-div-mobile'>
              <button onClick={() => changeLanguage('ro')} className='ro-btn' aria-label="Schimbă limba în Română">Ro</button>
              <button onClick={() => changeLanguage('en')} className='en-btn' aria-label="Switch language to English">En</button>
          </div>
          </div>
       </nav>
       )}
       <Suspense fallback={<div style={{minHeight:'60vh',display:'flex',alignItems:'center',justifyContent:'center'}}><div className="loading-spinner"></div></div>}>
         <Routes>
           <Route path="/" element={<Acasa />} />
           <Route path="/despre" element={<Despre />} />
           <Route path="/servicii" element={<Servicii />} />
           <Route path="/contact" element={<Contact />} />
           <Route path="/admin" element={<Admin />} />
           <Route path="*" element={<Navigate to="/" replace />} />
         </Routes>
       </Suspense>
       
       {!isAdminPage && <Footer />}
    </div>
  );
}

export default App;
